let readyPromise = null;

export const waitForOneSignal = () => {
  if (readyPromise) return readyPromise;
  readyPromise = new Promise(resolve => {
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(OneSignal => resolve(OneSignal));
  });
  return readyPromise;
};

export const isPushOptedIn = () => {
  try {
    return !!window.OneSignal?.User?.PushSubscription?.optedIn;
  } catch (_) {
    return false;
  }
};

export const setPushOptIn = async enabled => {
  const OneSignal = await waitForOneSignal();
  if (enabled) {
    // Demande native du téléphone d'abord : optIn() seul peut s'appuyer sur l'invite de
    // OneSignal, désactivée au profit du bandeau de l'application.
    if (typeof Notification !== 'undefined' && Notification.permission === 'default') {
      await OneSignal.Notifications.requestPermission();
    }
    await OneSignal.User.PushSubscription.optIn();
  } else {
    await OneSignal.User.PushSubscription.optOut();
  }
};

export const onPushSubscriptionChange = cb => {
  const OneSignal = window.OneSignal;
  if (!OneSignal?.User?.PushSubscription) return () => {};
  const handler = ev => cb(!!ev?.current?.optedIn);
  OneSignal.User.PushSubscription.addEventListener('change', handler);
  return () => OneSignal.User.PushSubscription.removeEventListener('change', handler);
};

// Adresse ouverte par un clic sur une notification (événement « click » du SDK v16).
export const notificationClickUrl = event =>
  event?.result?.url || event?.notification?.launchURL || event?.notification?.url || null;

export const onNotificationClick = cb => {
  const {OneSignal} = window;
  if (!OneSignal?.Notifications?.addEventListener) return () => {};
  const handler = event => {
    const url = notificationClickUrl(event);
    if (url) cb(url);
  };
  OneSignal.Notifications.addEventListener('click', handler);
  return () => OneSignal.Notifications.removeEventListener('click', handler);
};

// Rattache l'abonnement de ce téléphone au membre connecté, par son identifiant neutre
// (aucune donnée personnelle transmise à OneSignal).
export const loginPushUser = async pushId => {
  const OneSignal = await waitForOneSignal();
  if (OneSignal.User?.externalId === pushId) return;
  await OneSignal.login(pushId);
};

export const logoutPushUser = async () => {
  const OneSignal = await waitForOneSignal();
  if (OneSignal.User?.externalId) await OneSignal.logout();
};

// Notifications refusées au niveau du téléphone : seul le réglage du système les rétablit.
export const isPushBlocked = () =>
  typeof Notification !== 'undefined' && Notification.permission === 'denied';
